import { ThemeUICSSObject, responsive, spacing } from '@apia/theme';

const about: ThemeUICSSObject = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: spacing(7),
  justifyContent: 'center',

  '&.columns-1': {
    width: '332px',
  },
  '&.columns-2': {
    width: responsive({
      0: '332px',
      3: '664px',
    }),
  },
  '&.columns-3': {
    width: responsive({
      0: '332px',
      3: '664px',
      5: '996px',
    }),
  },

  '& > .about__card': {
    backgroundColor: '#fafafa',
    color: 'palette.text.primary',
    display: 'flex',
    flexDirection: 'column',
    textDecoration: 'none',
    width: '300px',

    '.about__card__imageContainer': {
      alignItems: 'center',
      display: 'flex',
      height: '120px',
      justifyContent: 'center',
    },

    '.about__card__description': {
      p: spacing(6),
    },
  },
};

export default about;
